import React, { useState, useEffect } from 'react'
import { Formik, Field, Form } from 'formik'
import { Input, FormGroup, Label, Button, Card, CardBody, CardTitle, Row, Col, ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import PropTypes from 'prop-types';
import Dropzone from "react-dropzone"
import { Link } from "react-router-dom"
import { useQuery } from 'react-query';
import { addNewJournal, getJournals } from 'helpers/fakebackend_helper';
import { QueryClient, useMutation } from 'react-query';


JournalCreateFrom.propTypes = {
  closeModal: PropTypes.func,
  isEditing: PropTypes.bool,
  initialValues: PropTypes.shape({
    name: PropTypes.string,
    content: PropTypes.string,
    images: PropTypes.arrayOf(PropTypes.string),  // Array of files
  }),
};
export default function JournalCreateFrom({ closeModal, isEditing = false, initialValues = {} }) {
  const [dropdownOpen, setDropdownOpen] = useState(false)
  // const [category, setCategory] = useState(initialValues.category || '')
  const [selectedFiles, setselectedFiles] = useState([])
  const [rawFiles, setRawFiles] = useState([])

  const { data: journalCategory, isLoading } = useQuery('journal_list', getJournals, {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  const queryClient = new QueryClient()

  const { mutate: addJournal, isLoading: isAddLoading } = useMutation(addNewJournal);



  const toggleDropdown = () => setDropdownOpen(!dropdownOpen)

  const handleSubmit = (values, { resetForm }) => {
    const formData = new FormData();
    formData.append('name', values.name);
    formData.append('content', values.content);
    rawFiles.forEach((file, index) => {
      formData.append(`photo_url[${index}]`, file);
    });
    for (let pair of formData.entries()) {
      console.log(`${pair[0]}: ${pair[1]}`);
    }
    // if (isEditing) {
    //   console.log('Editing expense:', formData);

    //   formData.append('expense_category_id', values.category.id);
    //   formData.append('status', values.status);
    //   formData.append('id', values.id);

    //   editExpense(formData, {
    //     onSuccess: () => {
    //       queryClient.invalidateQueries('expense_list');
    //       resetForm(); // Call resetForm here
    //       setRawFiles([])
    //       closeModal()
    //     }
    //   });
    // } else {

      console.log('Adding expense:', formData);
      addJournal(formData, {
        onSuccess: () => {
          queryClient.invalidateQueries('journal_list');
          resetForm(); // Call resetForm here
          setRawFiles([])
          closeModal()
        }
      });




    // }
  }

  function handleAcceptedFiles(files) {
    setRawFiles(files)
    console.log(files)
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    )
    setselectedFiles(files)
  }

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }

  return (
    <Formik
      initialValues={{
        name: initialValues.name || '',
        content: initialValues.content || '',
        
      }}
      onSubmit={handleSubmit}
    >
      {({ handleChange, values }) => (
        <Card className="mx-auto"  >
          <CardBody>
            <CardTitle className="text-center" tag="h2">
              {isEditing ? 'Edit Journal' : 'Add Journal'}
            </CardTitle>
            <Form>
              <div className="mx-auto">
                <FormGroup >
                  <Label for="name">Name</Label>
                  <Field
                    name="name"
                    as={Input}
                    id="name"
                    placeholder="Enter name"
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="description">Description</Label>
                  <Field
                    name="content"
                    as={Input}
                    type="textarea"
                    id="description"
                    placeholder="Enter journal description"
                  />
                </FormGroup>
                 

                <FormGroup>
                  <Label for="images">Images</Label>
                  <Dropzone
                    onDrop={acceptedFiles => {
                      handleAcceptedFiles(acceptedFiles)
                    }}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <div className="dropzone" style={{ height: '50px' }}>
                        <div
                          className="dz-message needsclick mt-2"
                          {...getRootProps()}
                        >
                          <input {...getInputProps()} />
                          <div className="mb-3">
                            <i className="display-4 text-muted bx bxs-cloud-upload" />
                          </div>
                          <h4>Drop files here or click to upload Journal images</h4>
                        </div>
                      </div>
                    )}
                  </Dropzone>
                  <div className="dropzone-previews mt-3" id="file-previews">
                    {selectedFiles.map((f, i) => {
                      return (
                        <Card
                          className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                          key={i + "-file"}
                        >
                          <div className="p-2">
                            <Row className="align-items-center">
                              <Col className="col-auto">
                                <img
                                  data-dz-thumbnail=""
                                  height="80"
                                  className="avatar-sm rounded bg-light"
                                  alt={f.name}
                                  src={f.preview}
                                />
                              </Col>
                              <Col>
                                <Link
                                  to="#"
                                  className="text-muted font-weight-bold"
                                >
                                  {f.name}
                                </Link>
                                <p className="mb-0">
                                  <strong>{f.formattedSize}</strong>
                                </p>
                              </Col>
                            </Row>
                          </div>
                        </Card>
                      )
                    })}
                  </div>
                </FormGroup>


              </div>
              <div className="mt-5 d-flex justify-content-end">
                <Button color="secondary" type="button" style={{ backgroundColor: "#2F8C47",marginRight: '12px' }} onClick={closeModal}  >
                  Close
                </Button>
                <Button color="primary" type="submit" style={{ backgroundColor: "#2F8C47" }} disabled={isEditing ? isEditLoading : isAddLoading}>
                  {(isEditing ? isEditLoading : isAddLoading) ? 'Loading...' : (isEditing ? 'Update Journal' : 'Submit Journal')}
                </Button>
              </div>

            </Form>
          </CardBody>
        </Card>
      )}
    </Formik>
  )
}


